import { apiFetch } from '../api-client';

export interface BankMaster {
  id: string;
  code: string;
  name: string;
  shortName: string | null;
  active: boolean;
  sortOrder: number;
}

export interface UpsertBankInput {
  code?: string;
  name?: string;
  shortName?: string | null;
  active?: boolean;
  sortOrder?: number;
}

export const banksApi = {
  list: () => apiFetch<BankMaster[]>('/api/banks'),
  create: (input: UpsertBankInput) => apiFetch<BankMaster>('/api/banks', { method: 'POST', body: JSON.stringify(input) }),
  update: (id: string, input: UpsertBankInput) => apiFetch<BankMaster>(`/api/banks/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),
  remove: (id: string) => apiFetch<{ ok: true }>(`/api/banks/${id}`, { method: 'DELETE' }),
};
